import type { TranslationDict } from '../en';

const pl: TranslationDict = {
  'header.buy': 'Kup',
  'header.sell': 'Sprzedaj',
  'spend.label': 'Wydajesz',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Otrzymujesz',
  'payment.label': 'Metoda płatności',
  'payment.select': 'Wybierz',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Brak metod płatności dla tej pary',
  'wallet.label': 'Adres portfela odbiorczego',
  'wallet.placeholderBuy': 'Wpisz swój adres odbiorczy',
  'wallet.placeholderSell': 'Wpisz swój adres nadawczy',
  'wallet.validating': 'Weryfikowanie adresu...',
  'wallet.invalid': 'Wpisz prawidłowy adres portfela',
  'wallet.invalidServer': 'Nieprawidłowy adres portfela',
  'cta.buy': 'Kup {crypto}',
  'cta.sell': 'Sprzedaj {crypto}',
  'cta.gettingPrice': 'Szukanie najlepszej ceny...',
  'cta.processing': 'Przetwarzanie...',
  'footer.poweredBy': 'Obsługiwane przez ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Szczegóły kursu',
  'rate.close': 'Zamknij',
  'rate.updatesIn': 'Kurs odświeży się za 00:{seconds}',
  'rate.noQuote': 'Brak dostępnej wyceny',
  'rate.exchangeRate': 'Kurs wymiany',
  'rate.processingFee': 'Opłata za przetwarzanie',
  'rate.networkFee': 'Opłata sieciowa',
  'rate.provider': 'Dostawca',
  'toast.orderCreated': 'Zlecenie utworzone',
  'toast.redirecting': 'Przekierowywanie do kasy...',
  'toast.orderFailed': 'Zlecenie nie powiodło się',
  'toast.couldNotCreate': 'Nie udało się utworzyć zlecenia',
  'toast.quoteError': 'Błąd wyceny',
  'toast.noProviders': 'Brak dostawców',
  'toast.somethingWrong': 'Coś poszło nie tak',
  'error.amountZero': 'Kwota musi być większa niż 0',
  'error.minAmountFiat': 'Minimalna kwota to {min} {currency}',
  'error.minAmountCrypto': 'Minimalna kwota to {min} {currency}',
  'error.noProviders': 'Brak dostępnych dostawców dla tej kombinacji',
  'error.currencyUnavailableBuy': 'Ta waluta nie jest dostępna do kupna',
  'error.currencyUnavailableSell': 'Ta waluta nie jest dostępna do sprzedaży',
  'parity.info': 'Zostaniesz obciążony za {receiveAmount} {crypto}, reszta do {spendAmount} {fiat} zostanie przypisana do Twojego konta {partner}',
  'redirect.secureBadge': 'Bezpieczna płatność',
  'redirect.title': 'Kontynuuj płatność',
  'redirect.description': 'Zostaniesz przekierowany do {gateway}, aby dokończyć płatność.',
  'redirect.countdown': 'Przekierowanie za {seconds}...',
  'redirect.openTab': 'Otwórz ACH w nowej karcie',
  'redirect.cancel': 'Anuluj',
  'checkout.noOrder': 'Nie znaleziono zlecenia',
  'checkout.goBack': 'Wróć',
  'checkout.expired': 'Sesja wygasła',
  'checkout.expiredDesc': 'Sesja wygasła. Spróbuj ponownie.',
  'checkout.startOver': 'Zacznij od nowa',
  'checkout.cancel': 'Anuluj',
  'checkout.loading': 'Ładowanie kasy...',
  'checkout.iframeTitle': 'Kasa dostawcy',
  'checkout.widgetTitle': 'Kasa płatności',
  'checkout.unknownMethod': 'Nieznana metoda realizacji',
  'processing.default': 'Przetwarzanie Twojego zlecenia...',
  'processing.pending': 'Oczekiwanie na potwierdzenie płatności...',
  'processing.active': 'Przetwarzanie Twojej transakcji...',
  'processing.generic': 'Przetwarzanie...',
  'processing.checkingStatus': 'Sprawdzanie statusu...',
  'processing.orderId': 'ID zlecenia',
  'processing.provider': 'Dostawca',
  'processing.amount': 'Kwota',
  'processing.receiving': 'Otrzymujesz',
  'processing.network': 'Sieć',
  'processing.toAddress': 'Adres docelowy',
  'processing.usuallyMinutes': 'To zwykle zajmuje kilka minut.',
  'processing.safeToClose': 'Możesz bezpiecznie zamknąć tę stronę — wyślemy Ci e-mail po zakończeniu.',
  'complete.buyTitle': 'Zakup zakończony!',
  'complete.sellTitle': 'Sprzedaż zakończona!',
  'complete.buyDesc': 'Twoje {crypto} zostało wysłane na Twój portfel.',
  'complete.sellDesc': 'Twoja wypłata w {fiat} jest przetwarzana.',
  'complete.amountBuy': 'Otrzymana kwota',
  'complete.amountSell': 'Sprzedana kwota',
  'complete.paidBuy': 'Zapłacona kwota',
  'complete.paidSell': 'Kwota wypłaty',
  'complete.network': 'Sieć',
  'complete.wallet': 'Portfel',
  'complete.transaction': 'Transakcja',
  'complete.provider': 'Dostawca',
  'complete.orderId': 'ID zlecenia',
  'complete.completed': 'Ukończono',
  'complete.viewExplorer': 'Zobacz w eksploratorze',
  'complete.done': 'Gotowe',
  'errorStep.failed': 'Płatność nie powiodła się',
  'errorStep.cancelled': 'Zlecenie anulowane',
  'errorStep.expired': 'Zlecenie wygasło',
  'errorStep.refunded': 'Zlecenie zwrócone',
  'errorStep.unknown': 'Coś poszło nie tak',
  'errorStep.failedBuy': 'Twoja płatność nie mogła zostać przetworzona. Spróbuj ponownie lub użyj innej metody płatności.',
  'errorStep.failedSell': 'Twoja sprzedaż nie mogła zostać przetworzona. Spróbuj ponownie.',
  'errorStep.cancelledBuy': 'Twoje zlecenie zostało anulowane. Żadna płatność nie została przetworzona.',
  'errorStep.cancelledSell': 'Twoja sprzedaż została anulowana. Żadne kryptowaluty nie zostały przeniesione.',
  'errorStep.expiredBuy': 'Twoje zlecenie wygasło. Rozpocznij nowy zakup.',
  'errorStep.expiredSell': 'Twoje zlecenie wygasło. Rozpocznij nową sprzedaż.',
  'errorStep.refundedBuy': 'Twoja płatność została zwrócona. Środki powinny pojawić się na Twoim koncie w ciągu 5-10 dni roboczych.',
  'errorStep.refundedSell': 'Twoje kryptowaluty zostały zwrócone. Środki powinny wkrótce pojawić się w Twoim portfelu.',
  'errorStep.genericDesc': 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
  'errorStep.orderId': 'ID zlecenia',
  'errorStep.tryAgain': 'Spróbuj ponownie',
  'errorStep.startOver': 'Zacznij od nowa',
  'errorStep.return': 'Wróć',
  'errorStep.needHelp': 'Potrzebujesz pomocy? Skontaktuj się z ',
  'errorStep.reference': 'Numer referencyjny: {orderId}',
  'confirm.buyTitle': 'Potwierdź zakup',
  'confirm.sellTitle': 'Potwierdź sprzedaż',
  'confirm.loading': 'Ładowanie...',
  'confirm.provider': 'Dostawca',
  'confirm.youPay': 'Płacisz',
  'confirm.youSell': 'Sprzedajesz',
  'confirm.youReceive': 'Otrzymujesz',
  'confirm.wallet': 'Portfel',
  'confirm.network': 'Sieć',
  'confirm.refundAddress': 'Adres zwrotu',
  'confirm.parityNote': 'Pobrana kwota od dostawcy może się różnić. Reszta do {amount} {crypto} zostanie przypisana do Twojego konta {partner}.',
  'confirm.processing': 'Przetwarzanie...',
  'confirm.confirmPay': 'Potwierdź i zapłać',
  'confirm.confirmSell': 'Potwierdź i sprzedaj',
  'confirm.payout': 'Wypłata w {currency}',
  'modal.selectFiat': 'Wybierz walutę fiat',
  'modal.selectCrypto': 'Wybierz kryptowalutę',
  'modal.choosePayment': 'Wybierz metodę płatności',
  'modal.selectCountry': 'Wybierz swój kraj',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Popularne',
  'modal.recommended': 'Rekomendowane',
  'modal.noCurrencies': 'Nie znaleziono walut',
  'modal.noPaymentMethods': 'Nie znaleziono metod płatności',
  'modal.noCountries': 'Nie znaleziono krajów',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Lokalizacja',
  'settings.darkMode': 'Tryb ciemny',
  'settings.privacy': 'Polityka prywatności',
  'settings.terms': 'Warunki użytkowania',
  'settings.language': 'Język',
  // ─── Additional ───
  'modal.chooseRamp': 'Wybierz Ramp',
  'modal.bestPrice': 'Najlepsza cena',
  'modal.noQuotes': 'Brak dostępnych wycen dla tego żądania',
  'modal.noProvidersFound': 'Nie znaleziono dostawców',
  'payment.unavailableFor': 'Brak metod płatności dla {currency}',
  'skeleton.poweredBy': 'Obsługiwane przez NowRamp',
  'error.createOrderFailed': 'Nie udało się utworzyć zlecenia',
  'errorStep.returnToMerchant': 'Wróć do sprzedawcy',
  'confirm.cryptoOnNetwork': '{crypto} w sieci {network}',
  'payment.name.card': 'Karta',
  'payment.name.bankTransfer': 'Przelew bankowy',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default pl;
